module.exports = __webpack_public_path__ + "img/fixed-banner2025.a65c211c.png";